import React from 'react'

function TenderTextTrapezodial() {
  return (
    <embed src="\pdfs\EAT1.5.3.1_VA-T_Trapezoidal_displacement_outlet_01.2018_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextTrapezodial